import { createStore } from 'vuex'

function readPermissions() {
  try {
    const raw = localStorage.getItem('adminPermissions')
    return raw ? JSON.parse(raw) : []
  } catch (e) {
    return []
  }
}

export default createStore({
  state: {
    token: localStorage.getItem('token') || '',
    role: localStorage.getItem('role') || '',
    realName: localStorage.getItem('realName') || '',
    adminRoleCode: localStorage.getItem('adminRoleCode') || '',
    adminPermissions: readPermissions()
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    hasAdminPermission: (state) => (permission) => {
      if (state.role !== 'ADMIN') return false
      if (!permission) return true
      return (state.adminPermissions || []).includes(permission)
    }
  },
  mutations: {
    SET_USER(state, payload) {
      state.token = payload.token || ''
      state.role = payload.role || ''
      state.realName = payload.realName || ''
      state.adminRoleCode = payload.adminRoleCode || ''
      state.adminPermissions = payload.adminPermissions || []
      localStorage.setItem('token', state.token)
      localStorage.setItem('role', state.role)
      localStorage.setItem('realName', state.realName)
      localStorage.setItem('adminRoleCode', state.adminRoleCode)
      localStorage.setItem('adminPermissions', JSON.stringify(state.adminPermissions))
    },
    CLEAR_USER(state) {
      state.token = ''
      state.role = ''
      state.realName = ''
      state.adminRoleCode = ''
      state.adminPermissions = []
      localStorage.removeItem('token')
      localStorage.removeItem('role')
      localStorage.removeItem('realName')
      localStorage.removeItem('adminRoleCode')
      localStorage.removeItem('adminPermissions')
    }
  },
  actions: {
    logout({ commit }) {
      commit('CLEAR_USER')
    }
  }
})
